import React, { useState, useEffect, useRef } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import ClearIcon from "@mui/icons-material/Clear";
import { toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import {
  IconButton,
  MenuItem,
  Tooltip,
  Typography,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  FormControl,
  Card,
  Box,
} from "@mui/material";
import {
  StyledButton,
  StyledInputLabel,
  StyledSelect,
  StyledTextField,
  StyledTableCellHistory,
  StyledTableRowHistory,
  theme,
  OutlinedIconFab,
  StyledTableContainer,
} from "../StyledComponents";
import { ThemeProvider } from "styled-components";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { durationType } from "../initialData/initialData";
import Icon from "../Utils/Icons";
import dayjs from "dayjs";
import DurationAutocompleteField from "./DurationAutocompleteField";
import {
  durationUnitMap,
  normalizeLegacyDuration,
  parseCombinedDuration,
  formatCombinedDurationForDisplay,
} from "./durationUtils";

const AllergyIntolerance = ({
  allergyHistoryData,
  setAllergyHistoryData,
  activeHistorySection,
  setActiveHistorySection,
  startRecording,
  stopRecording,
  isAiEnabled,
}) => {
  console.log("Allergy History called", allergyHistoryData);
  const [allergyVars, setAllergyVars] = useState({
    allergy_type: null,
    allergy_description: "",
    note: "",
    allergy_code: null,
    clinical_status_description: "Active",
    condition_onset: "",
    condition_duration: "",
    onset_datetime: null,
    abatement_datetime: null,
  });
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [termSelectedOrAdded, setTermSelectedOrAdded] = useState(false);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [autocompleteData, setAutoCompleteData] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [suggestApiCalled, setSuggestApiCalled] = useState(false);
  const [debounceFunctionCalled, setDebounceFunctionCalled] = useState(false);
  const [drugName, setDrugName] = useState("");
  const [allergyEditIndex, setAllergyEditIndex] = useState(null);
  const [allergyError, setAllergyError] = useState("");
  const hasPendingDurationSelection = (durationValue) =>
    /^\d+$/.test(String(durationValue || "").trim());

  const { transcript, resetTranscript } = useSpeechRecognition();
  const [listeningOn, setListeningOn] = useState(false);
  const [mouseDownOnOption, setMouseDownOnOption] = useState(false);

  const debounceTimeout = useRef(null); // Use useRef to persist timeout
  const skipEffect = useRef(false);
  const optionChosen = useRef(false);

  useEffect(() => {
    setAuthToken(sessionStorage.getItem("accessToken"));
  }, [sessionStorage.getItem("accessToken")]);

  const startListening = () => {
    console.log("Start Listening");
    setActiveHistorySection("Allergies");
    SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    setListeningOn(true);
  };
  useEffect(() => {
    // alert(`DH ${activeHistorySection}`);
    if (activeHistorySection == "Allergies") {
      let timerId;

      timerId = setTimeout(() => {
        if (allergyVars.allergy_type == "medication") {
          setDrugName(transcript);
        } else {
          setAllergyVars({
            ...allergyVars,
            allergy_description: transcript, // Use computed property name to set the field dynamically
          });
        }
      }, 3000);

      return () => {
        clearTimeout(timerId);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transcript]);

  useEffect(() => {
    if (skipEffect.current) {
      skipEffect.current = false; // reset after skipping
      return;
    }
    // Call the API with the debounced function when drugName changes

    let timerOut = setTimeout(() => {
      if (drugName.trim() !== "") {
        debouncedMedicineFilterCall(drugName.toLowerCase());
      }
    }, 500);
    return () => clearInterval(timerOut);
  }, [drugName]);

  // ── Date calculation helpers ──────────────────────────────────────────────
  const calculateOnsetDate = (duration, type) => {
    if (!duration || isNaN(parseInt(duration))) return null;
    const today = dayjs();
    return today.subtract(duration, durationUnitMap[type]);
  };

  const calculateAbatementDate = (onset_datetime, duration, type) => {
    if (!duration || isNaN(parseInt(duration)) || !onset_datetime) return null;
    return dayjs(onset_datetime).add(duration, durationUnitMap[type]);
  };
  // ─────────────────────────────────────────────────────────────────────────

  const handleAddAllergyRow = async () => {
    if (
      hasPendingDurationSelection(allergyVars.condition_onset) ||
      hasPendingDurationSelection(allergyVars.condition_duration)
    ) {
      setAllergyError("Please select a duration");
      return;
    }
    if (
      (allergyVars.allergy_description || drugName.length > 0) &&
      allergyVars.allergy_type
    ) {
      // Store the updated state in a local variable
      let newRow;

      if (allergyVars.allergy_type == "medication") {
        let newDetails,
          updatedFound = {},
          updatedSelectedOptiondetsils = {},
          foundData = false;

        if (!optionChosen.current) {
          const postBody = {
            term: drugName,
            state: "active",
            semantictag: "real clinical drug++clinical drug",
            acceptability: "synonyms",
            returnlimit: "100",
            refsetid: null,
            parentid: null,
            excludeparentconcept: false,
            fullconcept: true,
          };

          try {
            if (drugName.length > 1) {
              const response = await axios.get(
                `${REACT_APP_BACKEND_ROUTE_URL}search_medicines/?name=${drugName}`,
                // postBody,
                { headers: headers }
              );
              if (response) {
                console.log("Snomed Response", response);
                if (
                  response.data.status === "Success" &&
                  response.data.data.length > 0
                ) {
                  foundData = response.data.data.find(
                    (d) => d.term === drugName
                  );
                  console.log("Found Data", foundData);
                  if (foundData) {
                    updatedFound = {
                      ...foundData,
                      found: true,
                      id: foundData.conceptId,
                    };
                  } else {
                    updatedSelectedOptiondetsils = {
                      hierarchy: null,
                      isPreferredTerm: null,
                      conceptState: null,
                      conceptFsn: drugName,
                      definitionStatus: null,
                      conceptId: null,
                      languageCode: "en",
                      typeId: null,
                      term: drugName,
                      caseSignificanceId: "CASE_INSENSITIVE",
                      id: null,
                      effectiveTime: null,
                      activeStatus: null,
                      moduleId: null,
                    };
                  }
                } else {
                  updatedSelectedOptiondetsils = {
                    hierarchy: null,
                    isPreferredTerm: null,
                    conceptState: null,
                    conceptFsn: drugName,
                    definitionStatus: null,
                    conceptId: null,
                    languageCode: "en",
                    typeId: null,
                    term: drugName,
                    caseSignificanceId: "CASE_INSENSITIVE",
                    id: null,
                    effectiveTime: null,
                    activeStatus: null,
                    moduleId: null,
                  };
                }

                if (foundData) {
                  console.log("updatedFound", updatedFound);
                  newDetails = {
                    ...allergyVars,
                    allergy_description: updatedFound.term,
                    id: updatedFound.id,
                  };
                } else {
                  console.log(
                    "updatedSelectedOptiondetsils",
                    updatedSelectedOptiondetsils
                  );
                  newDetails = {
                    ...allergyVars,
                    allergy_description: updatedSelectedOptiondetsils.term,
                    id: updatedSelectedOptiondetsils.id,
                  };
                }
              } else {
                newDetails = {
                  ...allergyVars,
                  allergy_description: drugName,
                  id: null,
                };
              }
            }
          } catch (err) {
            console.log(err);
            // toast.error(err);
            newDetails = {
              ...allergyVars,
              allergy_description: drugName,
              id: null,
            };
          }
        } else {
          newDetails = { ...allergyVars };
        }
        console.log("allergyVars", allergyVars);
        newRow = {
          allergy_type: newDetails.allergy_type,
          allergy_description: newDetails.allergy_description,
          note: newDetails.note,
          clinical_status_description: newDetails.clinical_status_description,
          condition_onset: normalizeLegacyDuration(
            newDetails.condition_onset,
            newDetails.condition_onset,
            newDetails.condition_onset_type
          ),
          condition_duration: normalizeLegacyDuration(
            newDetails.condition_duration,
            newDetails.condition_duration,
            newDetails.condition_duration_type
          ),
          onset_datetime: newDetails?.onset_datetime
            ? dayjs(newDetails.onset_datetime).format("YYYY-MM-DD")
            : null,
          abatement_datetime: newDetails?.abatement_datetime
            ? dayjs(newDetails.abatement_datetime).format("YYYY-MM-DD")
            : null,
        };
      } else {
        newRow = {
          allergy_type: allergyVars.allergy_type,
          allergy_description: allergyVars.allergy_description,
          note: allergyVars.note,
          clinical_status_description: allergyVars.clinical_status_description,
          condition_onset: normalizeLegacyDuration(
            allergyVars.condition_onset,
            allergyVars.condition_onset,
            allergyVars.condition_onset_type
          ),
          condition_duration: normalizeLegacyDuration(
            allergyVars.condition_duration,
            allergyVars.condition_duration,
            allergyVars.condition_duration_type
          ),
          onset_datetime: allergyVars?.onset_datetime
            ? dayjs(allergyVars.onset_datetime).format("YYYY-MM-DD")
            : null,
          abatement_datetime: allergyVars?.abatement_datetime
            ? dayjs(allergyVars.abatement_datetime).format("YYYY-MM-DD")
            : null,
        };
      }

      console.log("newRow", newRow);
      const updatedRows = [...allergyHistoryData["new"], newRow];

      setAllergyHistoryData({
        ...allergyHistoryData,
        new: updatedRows,
      });
      // Reset family history variables and clear error
      setAllergyVars({
        allergy_type: allergyVars.allergy_type,
        allergy_description: "",
        note: "",
        allergy_code: null,
        clinical_status_description: "Active",
        condition_onset: "",
        condition_duration: "",
        onset_datetime: null,
        abatement_datetime: null,
      });
      setDrugName("");
      setAllergyError("");
      resetTranscript();
      setSuggestApiCalled(false);
      setDebounceFunctionCalled(false);
      setTermSelectedOrAdded(false);
      optionChosen.current = false;
      setFilteredOptions([]);
    } else {
      // Set error message if any field is missing
      setAllergyError("Allergy Description and Allergy Type is required");
    }
  };
  const handleAllergyEditClick = (row, rowIndex) => {
    if (row.allergy_type == "medication") {
      setDrugName(row.allergy_description);
    }
    setAllergyVars({
      allergy_type: row.allergy_type,
      allergy_description:
        row.allergy_type == "medication" ? "" : row.allergy_description,
      note: row.note,
      allergy_code: row.allergy_code,
      clinical_status_description: row.clinical_status_description,
      condition_onset: normalizeLegacyDuration(
        row?.condition_onset,
        row?.condition_onset,
        row?.condition_onset_type
      ),
      condition_duration: normalizeLegacyDuration(
        row?.condition_duration,
        row?.condition_duration,
        row?.condition_duration_type
      ),
      onset_datetime: row?.onset_datetime ? dayjs(row.onset_datetime) : null,
      abatement_datetime: row?.abatement_datetime
        ? dayjs(row.abatement_datetime)
        : null,
    });
    setAllergyEditIndex(rowIndex);
  };
  const handleAllergyUpdate = async () => {
    if (
      hasPendingDurationSelection(allergyVars.condition_onset) ||
      hasPendingDurationSelection(allergyVars.condition_duration)
    ) {
      setAllergyError("Please select a duration");
      return;
    }
    if (
      (allergyVars.allergy_description || drugName.length > 0) &&
      allergyVars.allergy_type
    ) {
      // Store the updated state in a local variable

      let updatedRow;

      if (allergyVars.allergy_type == "medication") {
        let newDetails,
          updatedFound = {},
          updatedSelectedOptiondetsils = {},
          foundData = false;

        if (!optionChosen.current) {
          const postBody = {
            term: drugName,
            state: "active",
            semantictag: "real clinical drug++clinical drug",
            acceptability: "synonyms",
            returnlimit: "100",
            refsetid: null,
            parentid: null,
            excludeparentconcept: false,
            fullconcept: true,
          };

          try {
            if (drugName.length > 1) {
              const response = await axios.get(
                `${REACT_APP_BACKEND_ROUTE_URL}search_medicines/?name=${drugName}`,
                // postBody,
                { headers: headers }
              );
              if (response) {
                console.log("Snomed Response", response);
                if (
                  response.data.status === "Success" &&
                  response.data.data.length > 0
                ) {
                  foundData = response.data.data.find(
                    (d) => d.term === drugName
                  );
                  console.log("Found Data", foundData);
                  if (foundData) {
                    updatedFound = {
                      ...foundData,
                      found: true,
                      id: foundData.conceptId,
                    };
                  } else {
                    updatedSelectedOptiondetsils = {
                      hierarchy: null,
                      isPreferredTerm: null,
                      conceptState: null,
                      conceptFsn: drugName,
                      definitionStatus: null,
                      conceptId: null,
                      languageCode: "en",
                      typeId: null,
                      term: drugName,
                      caseSignificanceId: "CASE_INSENSITIVE",
                      id: null,
                      effectiveTime: null,
                      activeStatus: null,
                      moduleId: null,
                    };
                  }
                } else {
                  updatedSelectedOptiondetsils = {
                    hierarchy: null,
                    isPreferredTerm: null,
                    conceptState: null,
                    conceptFsn: drugName,
                    definitionStatus: null,
                    conceptId: null,
                    languageCode: "en",
                    typeId: null,
                    term: drugName,
                    caseSignificanceId: "CASE_INSENSITIVE",
                    id: null,
                    effectiveTime: null,
                    activeStatus: null,
                    moduleId: null,
                  };
                }

                if (foundData) {
                  console.log("updatedFound", updatedFound);
                  newDetails = {
                    ...allergyVars,
                    allergy_description: updatedFound.term,
                    id: updatedFound.id,
                  };
                } else {
                  console.log(
                    "updatedSelectedOptiondetsils",
                    updatedSelectedOptiondetsils
                  );
                  newDetails = {
                    ...allergyVars,
                    allergy_description: updatedSelectedOptiondetsils.term,
                    id: updatedSelectedOptiondetsils.id,
                  };
                }
              } else {
                newDetails = {
                  ...allergyVars,
                  allergy_description: drugName,
                  id: null,
                };
              }
            }
          } catch (err) {
            console.log(err);
            // toast.error(err);
            newDetails = {
              ...allergyVars,
              allergy_description: drugName,
              id: null,
            };
          }
        } else {
          newDetails = { ...allergyVars };
        }
        updatedRow = {
          allergy_type: newDetails.allergy_type,
          allergy_description: newDetails.allergy_description,
          note: newDetails.note,
          clinical_status_description: newDetails.clinical_status_description,
          condition_onset: normalizeLegacyDuration(
            newDetails.condition_onset,
            newDetails.condition_onset,
            newDetails.condition_onset_type
          ),
          condition_duration: normalizeLegacyDuration(
            newDetails.condition_duration,
            newDetails.condition_duration,
            newDetails.condition_duration_type
          ),
          onset_datetime: newDetails?.onset_datetime
            ? dayjs(newDetails.onset_datetime).format("YYYY-MM-DD")
            : null,
          abatement_datetime: newDetails?.abatement_datetime
            ? dayjs(newDetails.abatement_datetime).format("YYYY-MM-DD")
            : null,
        };
      } else {
        updatedRow = {
          allergy_type: allergyVars.allergy_type,
          allergy_description: allergyVars.allergy_description,
          note: allergyVars.note,
          allergy_code: allergyVars.allergy_code,
          clinical_status_description: allergyVars.clinical_status_description,
          condition_onset: normalizeLegacyDuration(
            allergyVars.condition_onset,
            allergyVars.condition_onset,
            allergyVars.condition_onset_type
          ),
          condition_duration: normalizeLegacyDuration(
            allergyVars.condition_duration,
            allergyVars.condition_duration,
            allergyVars.condition_duration_type
          ),
          onset_datetime: allergyVars?.onset_datetime
            ? dayjs(allergyVars.onset_datetime).format("YYYY-MM-DD")
            : null,
          abatement_datetime: allergyVars?.abatement_datetime
            ? dayjs(allergyVars.abatement_datetime).format("YYYY-MM-DD")
            : null,
        };
      }
      const updatedAllergy = allergyHistoryData["new"].map((row, index) => {
        if (index === allergyEditIndex) {
          return updatedRow;
        } else {
          return row;
        }
      });
      setAllergyHistoryData({
        ...allergyHistoryData,
        new: updatedAllergy,
      });
      // Reset family history variables and clear error
      setAllergyVars({
        allergy_type: allergyVars.allergy_type,
        allergy_description: "",
        note: "",
        allergy_code: null,
        clinical_status_description: "Active",
        condition_onset: "",
        condition_duration: "",
        onset_datetime: null,
        abatement_datetime: null,
      });
      setAllergyEditIndex(null);
      setAllergyError("");
      setDrugName("");
      resetTranscript();
      setSuggestApiCalled(false);
      setDebounceFunctionCalled(false);
      setTermSelectedOrAdded(false);
      setFilteredOptions([]);
      optionChosen.current = false;
    } else {
      // Set error message if any field is missing
      setAllergyError("Allergy Description and Allergy Type is required");
    }
  };
  const handleAllergyDelete = (rowIndex) => {
    // Filter out the row at the specified index
    const updatedAllergy = allergyHistoryData["new"].filter(
      (row, index) => index !== rowIndex
    );
    // Update the state with the filtered array
    setAllergyHistoryData({
      ...allergyHistoryData,
      new: updatedAllergy,
    });
  };
  const handleChangeAllergy = (field, value) => {
    if (
      field === "allergy_description" &&
      allergyVars.allergy_type == "medication"
    ) {
      setAutoCompleteData([]);
      setFilteredOptions([]);
      setTermSelectedOrAdded(true);
    }

    let updatedDetails = { ...allergyVars, [field]: value };

    // NEW: condition_onset / condition_onset_type → calculate onset_datetime
    if (
      field === "condition_onset"
    ) {
      const onsetParsed = parseCombinedDuration(updatedDetails.condition_onset);
      updatedDetails.onset_datetime =
        onsetParsed.value && onsetParsed.unit
          ? calculateOnsetDate(
            parseInt(onsetParsed.value, 10),
            onsetParsed.unit
          )
          : null;
      const durationParsed = parseCombinedDuration(updatedDetails.condition_duration);
      if (durationParsed.value && durationParsed.unit) {
        updatedDetails.abatement_datetime =
          calculateAbatementDate(
            updatedDetails.onset_datetime,
            parseInt(durationParsed.value, 10),
            durationParsed.unit
          ) ?? null;
      }
    } else if (field === "condition_onset") {
      updatedDetails.onset_datetime = null;
    }

    // NEW: condition_duration / condition_duration_type → calculate abatement_datetime
    if (
      field === "condition_duration"
    ) {
      const durationParsed = parseCombinedDuration(updatedDetails.condition_duration);
      updatedDetails.abatement_datetime =
        durationParsed.value && durationParsed.unit
          ? calculateAbatementDate(
            updatedDetails.onset_datetime,
            parseInt(durationParsed.value, 10),
            durationParsed.unit
          )
          : null;
    } else if (field === "condition_duration") {
      updatedDetails.abatement_datetime = null;
    }

    setAllergyVars(updatedDetails);
  };

  const handleClearAllergyDescription = () => {
    setAllergyError("");
    setDrugName("");
    resetTranscript();
    setAllergyVars({
      ...allergyVars,
      allergy_description: "", // Use computed property name to set the field dynamically
    });
    setSuggestApiCalled(false);
    setDebounceFunctionCalled(false);
    setTermSelectedOrAdded(false);
    setFilteredOptions([]);
  };
  const debouncedMedicineFilterCall = async (medicine) => {
    let semanticTagForMedicineSearch = "real clinical drug++clinical drug";

    const postBodyForMedicine = {
      term: medicine,
      state: "active",
      semantictag: semanticTagForMedicineSearch,
      acceptability: "synonyms",
      returnlimit: "100",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (drugName.length > 1) {
        const response = await axios.get(
          `${REACT_APP_BACKEND_ROUTE_URL}search_medicines/?name=${drugName}`,
          // postBodyForMedicine,
          { headers: headers }
        );
        if (response) {
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            const dataToProcess =
              response.data.data.length > 300
                ? response.data.data.slice(0, 300)
                : response.data.data;

            const filteredData = dataToProcess.map((medicineItem) => {
              let modifiedTerm = medicineItem.term;

              if (medicineItem.conceptFsn.includes("(real clinical drug)")) {
                // Extract the first parentheses content (ingredient like paracetamol)
                const matches = medicineItem.conceptFsn.match(/\(([^)]+)\)/);
                if (matches && matches[1]) {
                  const ingredient = matches[1].trim();
                  modifiedTerm = `${medicineItem.term} (${ingredient})`;
                }
              }
              return {
                term: modifiedTerm,
              };
            });
            console.log("Filtered Medicine Data", filteredData);
            setAutoCompleteData(filteredData);
            setFilteredOptions(filteredData);
          } else {
            try {
              const response = await axios.post(
                `${REACT_APP_BACKEND_ROUTE_URL}snomed/suggest/`,
                postBodyForMedicine,
                { headers: headers }
              );
              if (response) {
                console.log("Suggest Response", response);
                if (
                  response.data.status === "Success" &&
                  response.data.data.length > 0
                ) {
                  setSuggestApiCalled(true);
                  const dataToProcess =
                    response.data.data.length > 300
                      ? response.data.data.slice(0, 300)
                      : response.data.data;
                  setAutoCompleteData(dataToProcess);
                  setFilteredOptions(dataToProcess);
                  // setSelectedFromSuggestion(true);
                } else {
                  // setSelectedFromSuggestion(true);

                  setAutoCompleteData([]);
                  setFilteredOptions([]);
                }
              }
            } catch (err) {
              console.log(err);
              toast.error(err);
            }
          }
          setDebounceFunctionCalled(true);
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  }; // Adjust the debounce duration (in milliseconds) as needed
  // const handleAddOption = async (term) => {
  //   const postBody = {
  //     term: term,
  //     state: "active",
  //     semantictag: "real clinical drug++clinical drug",
  //     acceptability: "synonyms",
  //     returnlimit: "-1",
  //     refsetid: null,
  //     parentid: null,
  //     excludeparentconcept: false,
  //     fullconcept: true,
  //   };

  //   try {
  //     if (drugName.length > 1) {
  //       const response = await axios.post(
  //         `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
  //         postBody,
  //         { headers: headers }
  //       );
  //       if (response) {
  //         let updatedFound = {},
  //           updatedSelectedOptiondetsils = {},
  //           foundData = false;
  //         console.log("Snomed Response", response);
  //         if (
  //           response.data.status === "Success" &&
  //           response.data.data.length > 0
  //         ) {
  //           foundData = response.data.data.find((d) => d.term === term);
  //           console.log("Found Data", foundData);
  //           if (foundData) {
  //             updatedFound = {
  //               ...foundData,
  //               found: true,
  //               id: foundData.conceptId,
  //             };
  //           } else {
  //             updatedSelectedOptiondetsils = {
  //               hierarchy: null,
  //               isPreferredTerm: null,
  //               conceptState: null,
  //               conceptFsn: term,
  //               definitionStatus: null,
  //               conceptId: null,
  //               languageCode: "en",
  //               typeId: null,
  //               term: term,
  //               caseSignificanceId: "CASE_INSENSITIVE",
  //               id: null,
  //               effectiveTime: null,
  //               activeStatus: null,
  //               moduleId: null,
  //             };
  //           }
  //         } else {
  //           updatedSelectedOptiondetsils = {
  //             hierarchy: null,
  //             isPreferredTerm: null,
  //             conceptState: null,
  //             conceptFsn: term,
  //             definitionStatus: null,
  //             conceptId: null,
  //             languageCode: "en",
  //             typeId: null,
  //             term: term,
  //             caseSignificanceId: "CASE_INSENSITIVE",
  //             id: null,
  //             effectiveTime: null,
  //             activeStatus: null,
  //             moduleId: null,
  //           };
  //         }

  //         setAutoCompleteData([]);
  //         setFilteredOptions([]);
  //         setSuggestApiCalled(false);
  //         setDebounceFunctionCalled(true);
  //         if (foundData) {
  //           handleChangeAllergy("allergy_description", updatedFound.term);
  //         } else {
  //           handleChangeAllergy(
  //             "allergy_description",
  //             updatedSelectedOptiondetsils.term
  //           );
  //         }
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     toast.error(err);
  //   }
  // };

  const handleConditionTyped = (value) => {
    setDrugName(value);

    // if (debounceTimeout.current) {
    //   clearTimeout(debounceTimeout.current); // Clear previous timeout
    // }

    // debounceTimeout.current = setTimeout(() => {
    //   handleAddOption(value); // Only triggers after user stops typing
    // }, 500); // Adjust delay as needed
  };

  return (
    <ThemeProvider theme={theme}>
      <Card
        sx={{
          borderRadius: "10px",
          boxShadow: "0 4px 4px 0 #C7C7CC inset",
          backgroundColor: "#FFF",
        }}
      >
        <Grid container spacing={2} sx={{ margin: "5px 0px", display: "flex" }}>
          <Grid item xs={11} sm={2} sx={{ margin: "5px 0px" }}>
            {/* <FormControl fullWidth> */}
            {/* <StyledInputLabel>Select Type</StyledInputLabel> */}
            <StyledTextField
              select
              label="Select Type"
              value={allergyVars.allergy_type}
              onChange={(e) =>
                handleChangeAllergy("allergy_type", e.target.value)
              }
              fullWidth
            >
              {["Food", "Medication", "Environment", "Biologic"].map((type) => (
                <MenuItem
                  key={type}
                  value={type.toLocaleLowerCase()}
                  sx={{ fontSize: "12px" }}
                >
                  {type}
                </MenuItem>
              ))}
            </StyledTextField>
            {/* </FormControl> */}
          </Grid>
          <Grid
            item
            xs={11}
            sm={6}
            sx={{ margin: "5px 0px", position: "relative" }}
          >
            <StyledTextField
              fullWidth
              label="Allergy Description"
              value={
                allergyVars.allergy_type == "medication"
                  ? // allergyVars.allergy_description !== ""
                  //   ? allergyVars.allergy_description
                  //   :
                  drugName
                  : allergyVars.allergy_description
              }
              onChange={(e) =>
                allergyVars.allergy_type == "medication"
                  ? // ? setDrugName(e.target.value)
                  handleConditionTyped(e.target.value)
                  : handleChangeAllergy("allergy_description", e.target.value)
              }
              onBlur={() => {
                setTimeout(() => {
                  const shouldClear = !mouseDownOnOption;

                  if (shouldClear) {
                    // setIsFocused(false);
                    setFilteredOptions([]);
                    setDebounceFunctionCalled(false);
                    setTermSelectedOrAdded(false);
                  }

                  setMouseDownOnOption(false);
                }, 100);
              }}
              onFocus={() => {
                // setIsFocused(true);
                if (drugName.trim() !== "") {
                  debouncedMedicineFilterCall(drugName.toLowerCase()); // re-trigger filtering
                }
              }}
              InputProps={{
                endAdornment: (
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <div style={{ marginRight: "5px" }}>
                      <Tooltip title="Clear">
                        <OutlinedIconFab
                          size="small"
                          variant="contained"
                          onClick={handleClearAllergyDescription}
                        >
                          <Icon name="clearTextField" size={32} />
                        </OutlinedIconFab>
                      </Tooltip>
                    </div>
                    {/* {allergyVars.allergy_type == "medication" &&
                    !termSelectedOrAdded && (
                      <Tooltip title="Add" style={{ marginRight: "5px" }}>
                        <OutlinedIconFab
                          size="small"
                          variant="contained"
                          onClick={() => handleAddOption("Medications")}
                        >
                          <AddIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    )} */}
                    <>
                      {isAiEnabled &&
                        (listeningOn == false ? (
                          <Tooltip title="Start Listening">
                            <OutlinedIconFab
                              // onClick={startListening}
                              onClick={() => {
                                startRecording();
                                setListeningOn(true);
                              }}
                              variant="contained"
                              color="defaultColor"
                              size="small"
                            >
                              <Icon name="micNotInUse" size={32} />
                            </OutlinedIconFab>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Stop Listening">
                            <OutlinedIconFab
                              onClick={() => {
                                // SpeechRecognition.stopListening();
                                stopRecording("Allergies");
                                setListeningOn(false);
                              }}
                              variant="outlined"
                              color="defaultColor"
                              size="small"
                            >
                              <Icon name="micInUse" size={32} />
                            </OutlinedIconFab>
                          </Tooltip>
                        ))}
                    </>
                  </div>
                ),
              }}
            />
            {allergyVars.allergy_type == "medication" &&
              filteredOptions.length > 0 ? (
              <div
                style={{
                  backgroundColor: "#f5f5f5",
                  borderRadius: "10px",
                  padding: "20px",
                  maxHeight: "200px", // Set your desired maximum height here
                  overflowY: "auto", // Add vertical scrolling
                  position: "absolute", // Position it absolutely
                  top: "100%", // Position it below the input field
                  left: 0,
                  right: 0,
                  zIndex: 1000, // Set a high z-index value to bring it over other elements
                }}
              >
                {/* Display filtered medicines */}
                {suggestApiCalled && (
                  <div style={{ color: "red" }}>
                    No Exact Matches found ! You can search for the following
                    Suggestions.
                  </div>
                )}

                <>
                  {filteredOptions.map((op) => (
                    <div key={op}>
                      {
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {op.added ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <StyledButton
                                color="success"
                                sx={{
                                  textAlign: "left",
                                  justifyContent: "flex-start",
                                  width: "100%",
                                }}
                              >
                                {op.term}
                              </StyledButton>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  flexDirection: "row",
                                  color: "green",
                                  fontStyle: "bold",
                                }}
                              >
                                <span>&#10003;</span>
                                <span>(Added)</span>
                              </div>
                            </div>
                          ) : (
                            <StyledButton
                              color="grey"
                              sx={{
                                textAlign: "left",
                                justifyContent: "flex-start",
                                width: "100%",
                              }}
                              onClick={() => {
                                skipEffect.current = true; // prevent debounce call
                                optionChosen.current = true;
                                setDrugName(op.term);
                                handleChangeAllergy(
                                  "allergy_description",
                                  op.term
                                );
                              }}
                              onMouseDown={() => setMouseDownOnOption(true)}
                            >
                              {op.term}
                            </StyledButton>
                          )}
                        </div>
                      }
                    </div>
                  ))}
                </>
              </div>
            ) : filteredOptions.length == 0 &&
              debounceFunctionCalled &&
              !termSelectedOrAdded ? (
              <div
                style={{
                  backgroundColor: "#f5f5f5",
                  borderRadius: "10px",
                  padding: "20px",
                  maxHeight: "300px", // Set your desired maximum height here
                  overflowY: "auto", // Add vertical scrolling
                }}
              >
                <div style={{ color: "red" }}>No Options Found!</div>
              </div>
            ) : null}
          </Grid>

          {/* ── Clinical Status ── */}
          <Grid item xs={11} sm={3} sx={{ margin: "5px 0px" }}>
            {/* <FormControl fullWidth> */}
            {/* <StyledInputLabel>Select Clinical Status</StyledInputLabel> */}
            <StyledTextField
              select
              label="Select Clinical Status"
              value={allergyVars.clinical_status_description}
              onChange={(e) =>
                handleChangeAllergy(
                  "clinical_status_description",
                  e.target.value
                )
              }
              fullWidth
            >
              {["Active", "Inactive", "Resolved"].map((relation) => (
                <MenuItem
                  key={relation}
                  value={relation}
                  sx={{ fontSize: "12px" }}
                >
                  {relation}
                </MenuItem>
              ))}
            </StyledTextField>
            {/* </FormControl> */}
          </Grid>


          <Grid container item xs={12} spacing={1} alignItems="center">
            <Grid
              item
              xs={11}
              sm={11}
              md={5}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <Tooltip title="How long ago this allergy started">
                <Typography
                  component="span"
                  variant="body2"
                  sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
                >
                  Allergy Onset:
                </Typography>
              </Tooltip>
              <Box sx={{ flex: 1, minWidth: { xs: 0, sm: 170, md: 190 } }}>
                <DurationAutocompleteField
                  label="Duration"
                  value={allergyVars.condition_onset || ""}
                  onChange={(combined) =>
                    handleChangeAllergy("condition_onset", combined)
                  }
                  durationType={durationType}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={11}
              sm={11}
              md={6}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <Tooltip title="How long this allergy has lasted">
                <Typography
                  component="span"
                  variant="body2"
                  sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
                >
                  Allergy Duration:
                </Typography>
              </Tooltip>
              <Box sx={{ flex: 1, minWidth: { xs: 0, sm: 170, md: 190 } }}>
                <DurationAutocompleteField
                  label="Duration"
                  value={allergyVars.condition_duration || ""}
                  onChange={(combined) =>
                    handleChangeAllergy("condition_duration", combined)
                  }
                  durationType={durationType}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={11}
              sm={11}
              md={2}
              sx={{
                margin: "5px 0px",
                display: "flex",
                justifyContent: { xs: "stretch", md: "flex-end" },
                padding: "0px",
              }}
            >
              <StyledButton
                bgColor="#0E3F66"
                variant="contained"
                sx={{ width: { xs: "100%" }, marginLeft: { md: "auto" } }}
                onClick={
                  allergyEditIndex !== null
                    ? handleAllergyUpdate
                    : handleAddAllergyRow
                }
                color="defaultColor"
              >
                {allergyEditIndex !== null ? "Update" : "Add"}
              </StyledButton>
            </Grid>
          </Grid>
          <Grid item xs={11} md={11} sm={11}>
            {allergyError && (
              <Typography style={{ color: "red" }}>{allergyError}</Typography>
            )}
          </Grid>
          <Grid item xs={11} sm={11}>
            {allergyHistoryData["prev"].length > 0 && (
              <StyledTableContainer
                component={Paper}
              // sx={{
              //   marginTop: "20px",
              //   border: "1px solid #21cdc0",
              // }}
              >
                <Table>
                  <TableHead>
                    <StyledTableRowHistory>
                      <StyledTableCellHistory>
                        Allergy Type
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        Allergy Description
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>Allergy Onset</StyledTableCellHistory>  {/* NEW */}
                      <StyledTableCellHistory>Allergy Duration</StyledTableCellHistory>{/* NEW */}
                      <StyledTableCellHistory>Clinical Status</StyledTableCellHistory>
                      <StyledTableCellHistory>Action</StyledTableCellHistory>
                    </StyledTableRowHistory>
                  </TableHead>
                  <TableBody>
                    {allergyHistoryData["prev"].map((row, rowIndex) => {
                      // console.log("Allergy Row", row); // Logging the row object

                      return (
                        <StyledTableRowHistory key={rowIndex}>
                          <StyledTableCellHistory>
                            {row?.allergy_type
                              ? row.allergy_type.charAt(0).toUpperCase() +
                              row.allergy_type.slice(1)
                              : "-"}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.allergy_description}
                          </StyledTableCellHistory>
                          {/* NEW COLUMNS */}
                          <StyledTableCellHistory>
                            {normalizeLegacyDuration(
                              row?.condition_onset,
                              row?.condition_onset,
                              row?.condition_onset_type
                            )
                              ? `${formatCombinedDurationForDisplay(
                                normalizeLegacyDuration(
                                  row?.condition_onset,
                                  row?.condition_onset,
                                  row?.condition_onset_type
                                )
                              )} ago`
                              : "-"}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {formatCombinedDurationForDisplay(
                              normalizeLegacyDuration(
                                row?.condition_duration,
                                row?.condition_duration,
                                row?.condition_duration_type
                              )
                            ) || "-"}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.clinical_status_description === ""
                              ? "-"
                              : row?.clinical_status_description}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>-</StyledTableCellHistory>
                        </StyledTableRowHistory>
                      );
                    })}
                  </TableBody>
                </Table>
              </StyledTableContainer>
            )}
          </Grid>

          {/* ── NEW Table ── */}
          <Grid item xs={11} sm={11}>
            {allergyHistoryData["new"].length > 0 && (
              <StyledTableContainer
                component={Paper}
              // sx={{
              //   marginTop: "20px",
              //   border: "1px solid #21cdc0",
              // }}
              >
                <Table>
                  <TableHead>
                    <StyledTableRowHistory>
                      <StyledTableCellHistory>
                        Allergy Type
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        Allergy Description
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>Allergy Onset</StyledTableCellHistory>  {/* NEW */}
                      <StyledTableCellHistory>Allergy Duration</StyledTableCellHistory>{/* NEW */}
                      <StyledTableCellHistory>Clinical Status</StyledTableCellHistory>
                      <StyledTableCellHistory>Action</StyledTableCellHistory>
                    </StyledTableRowHistory>
                  </TableHead>
                  <TableBody>
                    {allergyHistoryData["new"].map((row, rowIndex) => {
                      console.log("Allergy Row", row); // Logging the row object

                      return (
                        <StyledTableRowHistory key={rowIndex}>
                          <StyledTableCellHistory>
                            {row?.allergy_type.charAt(0).toUpperCase() +
                              row?.allergy_type.slice(1)}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.allergy_description}
                          </StyledTableCellHistory>
                          {/* NEW COLUMNS */}
                          <StyledTableCellHistory>
                            {normalizeLegacyDuration(
                              row?.condition_onset,
                              row?.condition_onset,
                              row?.condition_onset_type
                            )
                              ? `${formatCombinedDurationForDisplay(
                                normalizeLegacyDuration(
                                  row?.condition_onset,
                                  row?.condition_onset,
                                  row?.condition_onset_type
                                )
                              )} ago`
                              : "-"}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {formatCombinedDurationForDisplay(
                              normalizeLegacyDuration(
                                row?.condition_duration,
                                row?.condition_duration,
                                row?.condition_duration_type
                              )
                            ) || "-"}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.clinical_status_description === ""
                              ? "-"
                              : row?.clinical_status_description}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {allergyHistoryData["prev"].includes(row) ? (
                              "-"
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <Tooltip title="Edit">
                                  <OutlinedIconFab
                                    onClick={() =>
                                      handleAllergyEditClick(row, rowIndex)
                                    }
                                    sx={{ marginRight: 1 }}
                                  >
                                    <Icon name="editInTable" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                                <Tooltip title="Delete">
                                  <OutlinedIconFab
                                    onClick={() =>
                                      handleAllergyDelete(rowIndex)
                                    }
                                  >
                                    <Icon name="deleteInTable" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                              </div>
                            )}
                          </StyledTableCellHistory>
                        </StyledTableRowHistory>
                      );
                    })}
                  </TableBody>
                </Table>
              </StyledTableContainer>
            )}
          </Grid>
        </Grid>
      </Card>
    </ThemeProvider>
  );
};

export default AllergyIntolerance;
